import React, { useState, useId, useEffect } from 'react';
import './ImageUpload.css';

const ImageUpload = ({ currentImage, onUpload, label = 'Upload Image' }) => {
  const inputId = useId();
  const [preview, setPreview] = useState(currentImage || null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setPreview(currentImage || null);
  }, [currentImage]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    setUploading(true);

    try {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageData = event.target.result;
        setPreview(imageData);
        onUpload(imageData);
        setUploading(false);
      };
      reader.onerror = () => {
        alert('Error reading file');
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      alert('Error uploading image');
      setUploading(false);
    }
  };

  return (
    <div className="image-upload">
      <label className="image-upload-label">{label}</label>
      <div className="image-upload-container">
        {preview && (
          <div className="image-preview">
            <img src={preview} alt="Preview" />
            <button
              type="button"
              className="image-remove"
              onClick={() => {
                setPreview(null);
                onUpload(null);
              }}
            >
              ×
            </button>
          </div>
        )}
        <div className="image-upload-button-wrapper">
          <input
            type="file"
            id={inputId}
            accept="image/*"
            onChange={handleFileChange}
            className="image-upload-input"
            disabled={uploading}
          />
          <label htmlFor={inputId} className="image-upload-button">
            {uploading ? 'Uploading...' : preview ? 'Replace Image' : 'Choose Image'}
          </label>
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;

